/* -----------------------------------------------------------------------------------------------------
  - Created: [28-11-2025] by [SREERAJ]
  - Modified: [21-04-2025] by [SREERAJ]
  - Description:  - Description: This file contains  Equipment, Employee (leave & at site), Invoice details.
------------------------------------------------------------------------------------------------------- */

import React, { useContext } from "react";
import "./DashboardStatusGrid.css";
import { getPercent } from "../../../../utils/getPercent";
import StatusCard from "../StatusCard/StatusCard";
import { dashboardContext } from "../../Dashboard";
import CustomSkelton from "../../../../Components/Skeletons/CustomSkelton";
import { LiaFileInvoiceSolid, LiaToolsSolid } from "react-icons/lia";
import { RiGroupLine } from "react-icons/ri";
import UserStatusList from "../../ManagerDashboard/ManagerDashboardComponents/UserStatusList/UserStatusList";
import ScheduleStatus from "../ScheduleStatus/ScheduleStatus";
import RevenueStatistics from "../DashboardGraph/RevenueStatistics";
import { getUserRoleFlags } from "../../../../utils/userRoleUtils";

/**
 * Reusable dashboard grid wrapper.
 * Accepts any number of StatusCard components as children.
 */
const DashboardStatusGrid = () => {

    const { isSuperAdmin, isAdmin } = getUserRoleFlags()

    const { data, isLoading } = useContext(dashboardContext);
    //----------------------INVOCIE PERCENTAGE CALCULATEION START------------
    const paid = data?.paidInvoices || 0;
    const unpaid = data?.unpaidInvoices || 0;
    const total = data?.totalInvoices || 0; //paid + unpaid


    const paidPercent = getPercent(paid, total);
    const unpaidPercent = getPercent(unpaid, total);
    //----------------------INVOCIE PERCENTAGE CALCULATEION END------------

    //----------------------Employee Status PERCENTAGE CALCULATEION START------------
    const siteFse = data?.onSiteEngineersCount || 0;
    const leaveFse = data?.onLeaveEngineersCount || 0;
    const totalFse = data?.EmployeeCount || 0;  // active , on leave, on site employees count
    const availableFse = data?.availableEngineersCount || 0
    const inActiveFse = data?.InactiveuserCount || 0
    //----------------------Employee Status PERCENTAGE CALCULATEION END------------


    //---------------------- Equipment Status Percentage Calculation ----------------------

    const {
        ActiveEquipment = 0,
        InactiveEquipment = 0,
        onsiteEquipments = 0,
        totalEquipmentscounts = 0
    } = data ?? {};


    const ActiveEquipmentPercent = getPercent(ActiveEquipment, totalEquipmentscounts);
    const InactiveEquipmentPercent = getPercent(InactiveEquipment, totalEquipmentscounts);
    const OnsiteEquipmentsPercent = getPercent(onsiteEquipments, totalEquipmentscounts)

    //---------------------- End Equipment Status Percentage Calculation ----------------------

    return (
        <div className="dashGrid_mainWrapper">
               <ScheduleStatus />

            {isLoading ? (
                <>
                    <CustomSkelton variant="rectangular" height={320} />
                </>
            ) : (
                <StatusCard
                    uniqueKey="equipment"
                    title="Equipments"
                    data={[onsiteEquipments, ActiveEquipment, InactiveEquipment]}
                    labels={['At Site', 'Available', 'Inactive']} //'On Site',
                    colors={['#F1C40F', '#1DB954', '#7C96AB']} ///, '#E74C3C'
                    icon={<LiaToolsSolid />}
                    total={totalEquipmentscounts}
                    isShowPie={true}
                >
                    <div >
                        <div className='dashboard-status-container'>
                            <span className='dashboard-status-label'><span className='status-dot' style={{ color: '#F1C40F' }}>●</span> At Site {onsiteEquipments} ({OnsiteEquipmentsPercent})%</span>
                            <span className='dashboard-status-label'><span className='status-dot' style={{ color: '#1DB954' }}>●</span> Available  {ActiveEquipment} ({ActiveEquipmentPercent})%</span>
                            <span className='dashboard-status-label'><span className='status-dot' style={{ color: '#7C96AB' }}>●</span> Inactive  {InactiveEquipment} ({InactiveEquipmentPercent})%</span>
                        </div>
                    </div>
                </StatusCard>
            )}
            {isLoading ? (
                <>
                    <CustomSkelton variant="rectangular" height={320} />
                </>
            ) : (<StatusCard
                uniqueKey="employee"
                title="Employees"
                data={[siteFse, leaveFse, availableFse, inActiveFse]}
                labels={['At Site', 'On Leave', 'Available', 'Inactive']}
                colors={['#F39C12', '#3498DB', '#1DB954', '#7C96AB']}
                icon={<RiGroupLine />}
                total={totalFse}
                isShowPie={true}
            >
                <div className="dashboard-status-container">
                    <span className='dashboard-status-label'><span className='status-dot' style={{ color: '#F39C12' }}>●</span> At Site {siteFse} ({getPercent(siteFse, totalFse)})% </span>
                    <span className='dashboard-status-label'><span className='status-dot' style={{ color: '#3498DB' }}>●</span> On Leave {leaveFse} ({getPercent(leaveFse, totalFse)})%</span>
                    <span className='dashboard-status-label'><span className='status-dot' style={{ color: '#1DB954' }}>●</span> Available {availableFse} ({getPercent(availableFse, totalFse)})% </span>
                    <span className='dashboard-status-label'><span className='status-dot' style={{ color: '#7C96AB' }}>●</span> Inactive  {inActiveFse} ({getPercent(inActiveFse, totalFse)})% </span>

                </div>
            </StatusCard>)}

         

            {isLoading ? (
                <>
                    <CustomSkelton variant="rectangular" height={320} />
                </>
            ) : (
                <StatusCard
                    uniqueKey="invoice"
                    icon={<LiaFileInvoiceSolid />}
                    title="Invoice Status"
                    data={[paid, unpaid]}
                    labels={['Paid', 'Pending',]} //'Overdue'
                    colors={['#1DB954', '#F39C12',]} // '#E74C3C'
                    total={total}

                >
                    <div className='dashboard-status-container'>
                        <span className='dashboard-status-label'><span className='status-dot' style={{ color: '#1DB954' }}>●</span>
                            Paid {paid} ({paidPercent}%)
                        </span>
                        <span className='dashboard-status-label'><span className='status-dot' style={{ color: '#F39C12' }}>●</span>
                            Pending {unpaid} ({unpaidPercent}%)
                        </span>
                        {/* <div style={{ background: '#F9FAFB', padding: '1rem', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <IoWalletOutline className='manager_dashboard_icon' />
                                <span style={{ color: '#000000', fontWeight: 600, fontSize: '1.3rem' }}>Total Revenue: <span className='invoice-amount'>{data?.totalRevanue || 'N/A'}</span></span>
                            </div> */}
                    </div>
                </StatusCard>
            )}

            {(isSuperAdmin || isAdmin) &&

                <>
                    {isLoading ? (
                        <>
                            <CustomSkelton variant="rectangular" height={320} />
                        </>
                    ) : (
                        <RevenueStatistics />
                    )}

                </>}

        </div>
    );
};

export default DashboardStatusGrid;
